module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 6@2x.a0e7d586.png";